import React from 'react';
import Loader from '../../../utils/Loader';

const SummaryHeaderBox = ({ summaryReport, loading }) => {
  return (
    <div className="bg-white d-flex flex-column flex-md-row  justify-content-start justify-content-md-around big-number-table gray-border py-4 mb-4">
      {loading && <Loader />}
      {summaryReport &&
        summaryReport.columns &&
        summaryReport.columns.map((data, idx) => {
          const width = 100 / summaryReport.columns.length;

          return (
            <div
              key={idx}
              style={{ width: `${width}%` }}
              className="border-bar"
            >
              <div className="px-3">
                <div> {data.label || data.title} </div>
                {summaryReport.rows &&
                  summaryReport.rows.map((row, rowIdx) => {
                    return (
                      <div key={rowIdx} className="summary-table-value">
                        {summaryReport.rows[rowIdx][data.field || data.key]}
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default SummaryHeaderBox;
